import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
// Noto Sans, self-hosted, latin subset only, the four weights the type scale uses.
import '@fontsource/noto-sans/latin-400.css'
import '@fontsource/noto-sans/latin-500.css'
import '@fontsource/noto-sans/latin-600.css'
import '@fontsource/noto-sans/latin-700.css'
import './styles/tokens.css'
import './styles/base.css'
import './styles/print.css'
import i18n from './i18n'
import { App } from './app/App'
import { registerServiceWorker } from './app/registerServiceWorker'
import { applyPalette, applyTheme, getPaletteChoice, getThemeChoice } from './lib/theme'

applyTheme(getThemeChoice())
applyPalette(getPaletteChoice())
document.documentElement.lang = i18n.language

const container = document.getElementById('root')
if (!container) throw new Error('index.html must contain <div id="root">')

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
)

registerServiceWorker()
